<template>
    <div class="admin-quiz">
        <div class="admin-quiz__background">
            <img src="~@/assets/images/quiz-bgc.png" alt="kasanowa" />
        </div>
        <KLayoutWrapper>
            <template #default>
                <div>
                    <div class="admin-quiz__admin-title">{{ $t('quiz.quiz') }}</div>
                    <div class="admin-quiz__description">
                        <div>{{ $t('quiz.quizDescription1') }}</div>
                        <span>{{ $t('quiz.quizDescription2') }}</span>
                    </div>
                    <AdminQuizTable />
                    <div class="admin-quiz__btn-wrapper">
                        <KButton
                            id="create-quiz"
                            :label="$t('quiz.addNew')"
                            icon="arrowRight"
                            uppercase
                            :color="black"
                            @click="navigateTo('/quiz/create')"
                        />
                    </div>
                </div>
            </template>
        </KLayoutWrapper>
    </div>
</template>

<script setup lang="ts">
import { navigateTo } from '@/hooks/NavigateHooks';
import variables from '@/assets/scss/modules/variables.module.scss';
import KLayoutWrapper from '@/components/atoms/KLayoutWrapper.vue';
import AdminQuizTable from '@/views/Quiz/components/AdminQuizTable.vue';
import KButton from '@/components/atoms/KButton.vue';

const { black } = variables;

</script>

<style scoped lang="scss">
.admin-quiz {
    width: 100%;
    position: relative;

    &__background {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            height: calc(100% - 184px);
            min-height: calc(100vh - 184px);

            @include media-breakpoint-up(lg) {
                height: calc(100% - 217px);
                min-height: calc(100vh - 217px);
            }
        }
    }

    &__admin-title {
        background-color: $primary-400;
        color: $black;
        font-weight: 1000;
        padding: 8px;
        text-transform: uppercase;
        font-size: 20px;
        text-align: center;
        max-width: 520px;
        margin: 0 auto;

        @include media-breakpoint-up(lg) {
            font-size: 40px;
            padding: 18px 24px;
            max-width: 680px;
        }
    }

    &__description {
        margin-top: 17px;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        justify-content: center;
        color: $white;
        font-size: 18px;

        span {
            font-weight: 700;
            color: $primary-400;
        }
    }

    &__btn-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
}
</style>
